<template>
  <div class="partner-area">
    <div class="partner-group">
      <p class="partner-name">Premier Partner</p>
      <div class="partner-block">
        <a
          :href="`${PartnerLink.tokyoMetro[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-metoro.png`"
            alt=""
          />
        </a>
      </div>
    </div>
    <div class="partner-group">
      <p class="partner-name">Major Partners</p>
      <div class="partner-block">
        <a :href="`${PartnerLink.starts[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-starts.png`"
            alt=""
          />
        </a>
      </div>
      <div class="partner-block">
        <a :href="`${PartnerLink.ifing[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-ifing.png`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.asicsJapan[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-asics.png`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.otsukaPharmaceutical[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-otsuka2.jpg`"
            alt=""
          />
        </a>
      </div>
    </div>
    <div class="partner-group">
      <p class="partner-name">Main Partners</p>
      <div class="partner-block">
        <a
          :href="`${PartnerLink.kintetsuInternational[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-knt.png`"
            alt=""
          />
        </a>
        <a :href="`${PartnerLink.seiko[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-seiko.jpg`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.daiichiLife[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-daiichilife.png`"
            alt=""
          />
        </a>
      </div>
      <div class="partner-block">
        <a :href="`${PartnerLink.toray[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-toray.gif`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.mcdonalds[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-mac.jpg`"
            alt=""
          />
        </a>
      </div>
    </div>
    <div class="partner-group">
      <p class="partner-name">Active Partners</p>
      <div class="partner-block">
        <a
          :href="`${PartnerLink.mizuhoBank[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-mizuhobank.png`"
            alt=""
        /></a>
        <a
          :href="`${PartnerLink.kokuminKyosai[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-zenrosai.jpg`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.hisamitsuPharmaceutical[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-hisamitsu.jpg`"
            alt=""
          />
        </a>
      </div>
      <div class="partner-block">
        <a :href="`${PartnerLink.kao[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/kao2.jpg`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.bathclin[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/basukurin.jpg`"
            alt=""
          />
        </a>
        <a :href="`${PartnerLink.toppan[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/toppan.jpg`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.daiwaShoken[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr_daiwaShoken.png`"
            alt=""
          />
        </a>
      </div>
    </div>
    <div class="partner-group">
      <p class="partner-name">Supporting Partners</p>
      <div class="partner-block-wide">
        <a
          :href="`${PartnerLink.nihonKohden[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/nihonkoden.jpg`"
            alt=""
          />
        </a>
        <a :href="`${PartnerLink.koyou[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-rentia.jpg`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.fanplus[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-fanplus.jpg`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.shimizuOcto[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-shimizu.png`"
            alt=""
          />
        </a>
      </div>
      <div class="partner-block">
        <a
          :href="`${PartnerLink.tanakaKikinzoku[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-tanakaKikinzoku.jpg`"
            alt=""
          />
        </a>
        <a :href="`${PartnerLink.sagawa[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-sagawa.jpg`"
            alt=""
          />
        </a>
        <a
          :href="`${PartnerLink.photocreate[lang]}`"
          target="_blank"
          rel="noopener"
        >
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-allsports.jpg`"
            alt=""
          />
        </a>
        <a :href="`${PartnerLink.kddi[lang]}`" target="_blank" rel="noopener">
          <img
            class="partner-logo"
            :src="`https://tmf-virtualrun.jp/images/partner/${lang}/bnr-kddi.png`"
            alt=""
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PartnerLink from "../../assets/constants/event/partner/partner-link";
export default {
  data() {
    return {
      PartnerLink: PartnerLink,
    };
  },
  props: {
    lang: {
      type: String,
    },
  },
  name: "VirtualTokyoMarathon2022Partner",
};
</script>

<style scoped>
.partner-area {
  margin: 60px 0 0 0;
  text-align: center;
  .partner-group {
    margin: 40px 0 0 0;
    img.partner-logo {
      max-width: 100%;
    }
    a:not(:first-of-type) {
      margin-left: 10px;
    }
  }
  .partner-block {
    margin: 20px 0;
  }
  .partner-block-wide {
    a {
      display: inline-block;
      margin: 20px 0px 0px 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/VirtualTokyoMarathon2023Partner.vue